var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    "data-name": "Layer 2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h16v16H0z",
    "data-name": "Rectangle 12614"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#185edf",
    "data-name": "icons Q2",
    transform: "translate(1.333 1.333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 1.333V12H1.333V1.333H12M12.667 0h-12A.667.667 0 0 0 0 .667v12a.667.667 0 0 0 .667.667h12a.667.667 0 0 0 .667-.667v-12A.667.667 0 0 0 12.667 0z",
    "data-name": "Path 16756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 8.667H3.334a.667.667 0 1 0 0 1.333h6.667a.667.667 0 0 0 0-1.333z",
    "data-name": "Path 16757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 6H8a.667.667 0 1 0 0 1.333h2A.667.667 0 0 0 10 6z",
    "data-name": "Path 16758"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 3.333H8a.667.667 0 1 0 0 1.333h2a.667.667 0 0 0 0-1.333z",
    "data-name": "Path 16759"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 4,
    "data-name": "Rectangle 12615",
    rx: 1.5,
    transform: "translate(2.667 3.667)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContent);
export default __webpack_public_path__ + "static/media/content.0d40261ed8a1ae87580b429136285fe0.svg";
export { ForwardRef as ReactComponent };